export const btnAuth = {
    methods: {
        /**
         * 根据按钮名称筛选
         * @param {*} btnRouteName 按钮路由名称（需要和后台的权限按钮对应）
         * 
         * @return { Boolean } 是否有当前按钮
         */
        getBtnByAuth(btnRouteName) {
            // let parentId = this.$route.meta.parentId || '';
            // if(!parentId) return false;
            const authList = this.$utils.deepClone(this.$userInfoTool.getAuth());
            const btnList = authList.filter(item => item && item.level === 3);
            // return btnList.some(el => el.routeName === btnRouteName && parentId === el.parentId);
            return btnList.some(el => el.routeName === btnRouteName);
        }
    }
}
